module.exports = __webpack_public_path__ + "files/7842bee2d03dbecd7f96503a5b988e5e.png";